import React from 'react';
import PropTypes from 'prop-types';

// @todo: Move all titles specific styles to a index.styl inside this folder

const updateWindowHash = (id) => { window.location.hash = id; };

const Title = ({ children, anchor, tag }) => (
  <div
    id={anchor}
    className={`header-wrapper header-level-${tag}`}
    onClick={() => updateWindowHash(anchor)}
    dangerouslySetInnerHTML={{ __html: children }}
  />
);

Title.propTypes = {
  tag: PropTypes.oneOf(['h2', 'h3', 'h4', 'h5', 'h6']).isRequired,
  children: PropTypes.string.isRequired,
  anchor: PropTypes.string.isRequired
};

export default Title;
